import React, {Fragment, useEffect, useState} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {aprobarSolicitud, mostrarSolicitudById, rechazarSolicitud} from '../../redux/reducers/solicitudesReducer';
import {errorToNotifObj, geoString, hasPermissionTo, PERSMISOS} from '../../helpers';
import {
    Button,
    CircularProgress,
    FormControl,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    Snackbar,
    TextField,
    Theme,
    Typography
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
    SelectAgente,
    SelectCaja,
    SelectCartera,
    SelectDay,
    SelectEnum,
    SelectFiles,
    SelectPais,
    SelectRuta
} from "../../components/selects"
import {AppBar, HtmlTooltip, LoadingProgress, MostrarError, ReferenciasCliente} from "../../components";
import {DateInput, TextFieldCurrency, TextFieldPhone} from "../../components/CustomTextField";
import Strings from "../../assets/strings";
import Box from "@mui/material/Box";
import AddAdjuntos from "../../components/AddAdjuntos";
import {calcularTasa, cedulaExiste, editSolicitud, getInfoByCedula, postSolicitud} from "../../services";
import Swal from "sweetalert2";
import {useCustomFormInput} from "../../hooks/useCustomFormInput";
import MapSearch from "../../components/MapSearch";
import {CalculateOutlined, Check, Close, Edit, Save, SearchOutlined} from "@mui/icons-material";
import _ from "lodash";

import AmortCal from "../../components/calAmort";
import {isMobile} from "../../helpers/browser_detect";
import {ISolicitud} from "../../redux/types/ISolicitud";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {ConfCamposType} from "../../redux/types/ICompania";
import SelectUsoMultiples from "../../components/selects/SelectUsoMultiples";
import {IArchivo} from "../../redux/types/ICliente";
import Notifications from "react-notification-system-redux";
import {ESTADO_SOLICITUD} from "../../helpers/CONSTANTES";

const useStyles = makeStyles((theme:Theme) => ({
    root:{
        padding:"20px",
        "& form#form1":{
            marginBottom: theme.spacing(2)
        }
    },
    btn:{
        marginRight: 5,
        color:theme.palette.common.white,
        fontWeight:"normal",
    },
    avatar:{
        "& img":{
            maxWidth: 150
        },
        [theme.breakpoints.down('md')]: {
            "& img":{
                borderRadius: theme.shape.borderRadius,
            }
        }

    },
    submitBtn:{
        margin: 20,
    },
    preCont:{
        borderTop: "2px id " + theme.palette.secondary.main,
        paddingTop: theme.spacing(2),
        marginTop: theme.spacing(2)
    }
}));
let initialState:ISolicitud = {
    actualizarCliente:false,
    id: undefined,
    clienteTipo: 1,
    razonSocial:"",
    nombres: "",
    apellidos: "",
    email: "",
    cedula: "",
    paisIdNacionalidad: undefined,
    estadoCivilId: undefined,
    sexo: "",
    fechaNacimiento: "",
    celular: "",
    telefono: "",
    avatar: "",
    tipoVivienda: undefined,
    direccion: "",
    direccion2: "",
    coordenadas:"",
    condicionLaboral: undefined,
    trabajoNombre: "",
    trabajoDireccion: "",
    trabajoTelefono: "",
    trabajoPosicion: "",
    trabajoIntervaloCobro: undefined,
    diaCobro: "",
    ingresos: 0,
    tiempoLaborando: "",
  //  referenciaPersonal: "",
  //  telefonoRefPersonal: "",
    //----------
    codigoPostal: "",
    referencias: [],
    archivos:[],
    dependientes: 0,
    ruta: "",
    rutaId: undefined,
    carteraId:undefined,
    //prestamos
    prestamoReferencia:"",
    prestamoCapital: 0,
    plazo: 0,
    tasaInteres: 0,
    tipoAmortizacion: undefined,
    ciclosPago: 0,
    fechaProximoPago: "",
    diasExcluidos: "",
    cajaId: undefined,
    usuarioIdAgente:undefined,
    porcientoComision:0,
    porcientoMora:0,
    codeudor: "",
    codeudorCedula: "",
    codeudorTelefono: "",
    codeudorDireccion: "",


};

export default function DetallesSolicitud({lang, permitirDocumentos}:{lang?:any, permitirDocumentos?:boolean}){
    const classes = useStyles();
    let dispatch = useAppDispatch();
    let defaultCajId = useAppSelector(state => state.auth.user?.cajaIdDefault);
    let {isAuthenticated} = useAppSelector(state => state.auth);


    let {porcientoMora=0} = useAppSelector(state => state.companias.data || {});

    const webview = isMobile.anyWebView()

    const {state:urlState, pathname} = useLocation();

    const navigate = useNavigate();

    const customFormInputCli = useCustomFormInput() as ConfCamposType;
    const customFormInputPre = useCustomFormInput("prestamo") as ConfCamposType;
    const [editar, setEditar] = useState(false);

    const { user, id:urlSolId} = useParams();
    const isPrivate = (!!urlSolId && !user);


    let {byId:solicitud,error:reduxError, status} = useAppSelector(state => state.solicitudes);

    const [snackbarMsj, setSnackbarMsj] = useState(null);

    const [beforeEditState, setBeforeEditState] = useState({});

    const [state, setState] = useState(initialState);
    const [error, setError] = useState(reduxError);

    const [isPending, setIsPending] = useState(status === "loading");


    useEffect(()=>{
        if(urlSolId) dispatch(mostrarSolicitudById(parseInt(urlSolId)));
    },[urlSolId,dispatch]);

    useEffect(()=>{
        initialState = {...initialState, cajaId:defaultCajId,porcientoMora}

        if(!!solicitud?.id) {
            setState({...initialState,..._.omitBy(solicitud, (v:any) => _.isNil(v))});
        }else{
            setState(initialState)
        }
    },[solicitud,defaultCajId,porcientoMora]);

    //*******************
    const [buscandoID, setBuscandoID] = useState(false);
    const verificarCedula = () => {
        if(state.cedula) {
            setBuscandoID(true)
            getInfoByCedula(state.cedula).then((res) => {
                if(res.status === 200) {
                    Swal.fire({
                        title: `${Strings.prestatario} ${Strings.encontrado}`,
                        text: "Deseas autocompletar con los datos encontrados.",
                        showCancelButton: true,
                        cancelButtonText: Strings.cancelar,
                        confirmButtonText: "Auto Completar",
                    }).then((result) => {
                        let data = _.omitBy(res.data, (v) => !v || v === "0");
                        if (result.isConfirmed) {
                            setState(prevState =>  ({...prevState, ...data}))
                        }
                        // else if (result.isDenied) {
                        //     dispatch(aprobarSolicitud({...obj, actualizarCliente: false}));
                        // }
                    })
                }



                // if(res.status === 204){
                //     return dispatch(Notifications.warning({title: Strings.noSeEncontraron+" datos.", autoDismiss: 5}))
                // }
                // setState(prevState => ({...prevState,
                //     nombres: res.data.name??"",
                //     apellidos: res.data.lastName??"",
                //     sexo: res.data.gender??"",
                //     fechaNacimiento: res.data.birthdate??"",
                // }))
            }).finally(()=>setBuscandoID(false))
        }
    }
    //*******************

    // Reset fecha si se cambia a modalidad quincenal
    const {ciclosPago} = state
    useEffect(()=>{
        if(ciclosPago === 16){
            setState(prevState => ({...prevState,
                ciclosPago,
                fechaProximoPago: "",
            }));
        }
    },[ciclosPago]);

    const handleChange = (e:React.ChangeEvent<HTMLInputElement>)=>{
        const {name,value} = e.target;
        // console.log(name,value)
        if(name === "actualizarCliente"){
            return setState({...state,[name]: (value === "true")});
        }
        return setState({...state,[name]: value});
    };

    const submit = async (e:React.FormEvent<HTMLFormElement>) =>{
        e.preventDefault();
        let obj = {...state};
        if(isPrivate){
            if(obj?.avatar === solicitud?.avatar ) obj.avatar = "";
            obj.archivos = obj.archivos?.filter(item => item.base64 !== "-1")

            if(!!state?.montoCuota){
                const {prestamoCapital, plazo, tipoAmortizacion, montoCuota} = state;

                setFetchingTasa(true)
                await calcularTasa({
                    montoCuota: montoCuota ?? 0,
                    plazo: +(plazo ?? 0),
                    capital: +(prestamoCapital ?? 0),
                    tipoAmortizacion: +(tipoAmortizacion ?? 0)
                }).then(({data}) => {
                    setState(prevState => ({...prevState, tasaInteres: data}))
                    obj.tasaInteres = data;
                }).finally(()=>setFetchingTasa(false))

            }




            if(editar){
                setIsPending(true);
                editSolicitud(obj).then((res)=>{
                    setEditar(false);
                    setState(res.data)
                    // setSnackbarMsj(translateText("enviadoExitosoMsj"));
                }).finally(()=>setIsPending(false))
            }else{

                cedulaExiste(state.cedula??"").then(({data:existe})=>{
                    if(existe===true){
                        Swal.fire({
                            title:`${Strings.prestatario} ${Strings.encontrado}` ,
                            text:Strings.clienteEncontradoMsj,
                            showDenyButton:true,
                            showCancelButton: true,
                            cancelButtonText:Strings.cancelar,
                            denyButtonText:"No "+Strings.actualizar,
                            confirmButtonText: Strings.actualizar,
                        }).then((result) => {
                            if(result.isConfirmed){
                                dispatch(aprobarSolicitud({...obj,actualizarCliente:true}));
                            }else if(result.isDenied){
                                dispatch(aprobarSolicitud({...obj,actualizarCliente:false}));
                            }
                        })
                    }else{
                        Swal.fire({
                            title:Strings.confirmar,
                            showCancelButton: true,
                            cancelButtonText:Strings.cancelar,
                            confirmButtonText: Strings.aprobar,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                dispatch(aprobarSolicitud(obj));
                            }
                        })
                    }
                })

            }}
        else{
            setIsPending(true);
            postSolicitud(user!,obj).then(()=>{
                setState(initialState)

                // @ts-ignore
                Swal.fire({
                    title:"¡Solicitud enviada con éxito!",
                    text: 'Nos pondremos en contacto con usted a la mayor brevedad. Gracias',
                    icon:'success',
                    showCloseButton: true,
                    showConfirmButton: false,
                    // onClose: () => {
                    //     setState(initialState)
                    // }
                })
            }).catch(error=>{

                const {title, status, errors} = error?.response?.data;
                setError(title);
                window.scrollTo({ top: 0, behavior: 'smooth' });

                dispatch(Notifications.error(errorToNotifObj({Title:title, status, errors})))
            }).finally(()=>setIsPending(false))
        }
    };

    let cliTipo = state.clienteTipo;
    const estadoString = (id:number)=>{
        switch (id) {
            case 1:
                return Strings.pendiente;
            case 2:
                return Strings.aprobada;
            case 3:
                return Strings.rechazada;
            default:
                return ""
        }
    }
    const onClickEdit = ()=>{
        setBeforeEditState(state)
        setEditar(true)
    }
    const onCancelEdit = ()=>{
        setState(beforeEditState)
        setBeforeEditState({})
        setEditar(false)
    }
    const onRechazar = ()=>{
        Swal.fire({
            title:Strings.confirmar,
            showCancelButton: true,
            cancelButtonText:Strings.cancelar,
            confirmButtonText: Strings.rechazar,
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(rechazarSolicitud(state.id!))
            }
        })
    }

    const [fetchingTasa,setFetchingTasa] = useState(false);
    const getTasaInteres = () => {
        if(state.montoCuota && state.plazo && state.prestamoCapital && state.tipoAmortizacion) {
            setFetchingTasa(true)
            calcularTasa({
                montoCuota: state.montoCuota ?? 0,
                plazo: +(state.plazo ?? 0),
                capital: +(state.prestamoCapital ?? 0),
                tipoAmortizacion: +(state.tipoAmortizacion ?? 0)
            }).then(res => {
                setState(prev => ({...prev, tasaInteres: res.data}))
            }).finally(() => setFetchingTasa(false))
        }
    }
    return(
        <Fragment>
            {isPrivate &&
                <AppBar title={Strings.solicitud+" "+(estadoString(state.estado!))}/>
            }
            <div className={"contentInner " + classes.root}>
                {error && <>
                    <MostrarError errors={error}/>
                    <br/>
                </>}
                {(status === "loading" || isPending) && <LoadingProgress vh/>}
                <form id="form1" onSubmit={submit} autoComplete={"off"}>

                    <div className={"customCard"}>
                        <Typography color={"secondary"} className={"title"} >DATOS DEL CLIENTE</Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={2}>
                                <div className={classes.avatar}>
                                    <SelectFiles showImg src={state.avatar ? state.avatar : ""} emp={cliTipo === 2}
                                                 onChange={(baseb4:string)=>setState({ ...state, avatar: baseb4 } )}/>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={10}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <SelectEnum value={cliTipo} name={"clienteTipo"} label={Strings.tipo} required
                                                    onChange={handleChange} group={"tiposCliente"} />
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={3}>
                                        {isAuthenticated ? (
                                            <TextField
                                                name="cedula"
                                                label={geoString(cliTipo === 2 ? "rnc":"cedula",false)}
                                                placeholder={cliTipo === 2 ? geoString("rnc",false):""}
                                                value={state.cedula}
                                                onChange={handleChange}
                                                inputProps={{maxLength: 20}}
                                                fullWidth
                                                required
                                                disabled={buscandoID}
                                                InputProps={!state.id && cliTipo === 1 && (state.cedula?.length ?? 0) > 2 ? {
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <HtmlTooltip title={"Validar número de cédula."}>
                                                                <IconButton disabled={buscandoID} color={"primary"} onClick={verificarCedula} size="large">
                                                                    {buscandoID?<CircularProgress size={20} color="inherit"/>:<SearchOutlined/>}

                                                                </IconButton>
                                                            </HtmlTooltip>
                                                        </InputAdornment>
                                                    ),
                                                }:{}}
                                            />
                                        ):(
                                            <TextField
                                                name="cedula"
                                                label={cliTipo === 2 ?geoString("rnc",true):Strings.cedula}
                                                placeholder={cliTipo === 2 ?geoString("rnc"):""}
                                                value={state.cedula}
                                                onChange={handleChange}
                                                inputProps={{maxLength: 20}}
                                                fullWidth
                                                required
                                            />
                                        )}

                                    </Grid>
                                    {cliTipo === 2 &&
                                    <Grid item xs={12} sm={4} md={3}>
                                        <TextField
                                            name={"razonSocial"}
                                            label={Strings.razonSocial}
                                            value={state.razonSocial}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 50}}
                                            required
                                            fullWidth
                                        />
                                    </Grid>}
                                    <Grid item xs={12} sm={4} md={3}>
                                        <TextField
                                            name="nombres"
                                            label={Strings.primerNombre}
                                            placeholder={cliTipo === 2 ? Strings.representante:""}
                                            value={state.nombres}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 50}}
                                            required
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <TextField
                                            name="apellidos"
                                            label={Strings.apellidos}
                                            placeholder={cliTipo === 2 ? Strings.representante:""}
                                            value={state.apellidos}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 50}}
                                            required
                                            fullWidth
                                        />
                                    </Grid>

                                    {cliTipo !== 2 &&
                                        <Grid item xs={6} sm={4} md={3}>
                                            <FormControl fullWidth >
                                                <InputLabel>{Strings.genero}</InputLabel>
                                                <Select
                                                    value={state.sexo}
                                                    onChange={({target})=>setState({...state,sexo: target.value})}
                                                    input={<Input name="sexo" />}
                                                >
                                                    <MenuItem value="">{Strings.seleccione}</MenuItem>
                                                    <MenuItem value="M">{Strings.masculino}</MenuItem>
                                                    <MenuItem value="F">{Strings.femenino}</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    }
                                    <Grid item xs={12} sm={4} md={3}>
                                        <TextFieldPhone
                                            name="celular"
                                            label={Strings.celular}
                                            value={state.celular}
                                            onChange={handleChange}
                                            fullWidth
                                            required={(state.telefono?.length??0)<4}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={3}>
                                        <TextFieldPhone
                                            name="telefono"
                                            label={Strings.telefono}
                                            value={state.telefono}
                                            onChange={handleChange}
                                            required={(state.celular?.length??0)<4}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={6} md={3} sx={{display:{xs:"none",sm:"flex"}}}>
                                        <SelectPais
                                            name="paisIdNacionalidad"
                                            display="nacionalidad"
                                            label={Strings.nacionalidad}
                                            value={state.paisIdNacionalidad}
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <br/>
                        <Grid container spacing={3}>
                            <Grid item xs={6} sm={6} md={3} sx={{display:{xs:"flex",sm:"none"}}}>
                                <SelectPais
                                    name="paisIdNacionalidad"
                                    display="nacionalidad"
                                    label={Strings.nacionalidad}
                                    value={state.paisIdNacionalidad}
                                    onChange={handleChange}
                                />
                            </Grid>
                            {cliTipo !== 2 && <>
                                <Grid item xs={6} sm={3} md={3}>
                                    <SelectEnum value={state.tipoVivienda} name={"tipoVivienda"} label={Strings.vivienda}
                                                onChange={handleChange} group={"tiposVivienda"} />
                                </Grid>
                                <Grid item xs={6} sm={3} md={4} lg={cliTipo ===2?2: 3}>
                                    <SelectEnum value={state.condicionLaboral} name={"condicionLaboral"} label={Strings.condicionesLaboral}
                                                    onChange={handleChange} group={"condicionesLaboral"} />
                                </Grid>
                                <Grid item xs={6} sm={3} md={3} lg={2}>
                                    <TextFieldCurrency
                                        name="ingresos"
                                        label={Strings.ingreso}
                                        value={state.ingresos}
                                        onChange={handleChange}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={6} sm={3} md={2}>
                                    <SelectEnum value={state.estadoCivilId} name={"estadoCivilId"} label={Strings.estadoCivil}
                                                onChange={handleChange} group={"estadosCivil"} />
                                </Grid>

                                <Grid item xs={6} sm={3} md={2}>
                                    <TextField
                                        name="dependientes"
                                        label={Strings.dependientes}
                                        value={state.dependientes}
                                        type="number"
                                        inputProps={{step:1,inputMode:"numeric"}}
                                        onChange={handleChange}
                                        fullWidth
                                    />
                                </Grid>
                            </>}
                            <Grid item xs={12} sm={cliTipo === 2?6:9} md={cliTipo === 2?6:5} lg={5}>
                                {/*<TextField*/}
                                {/*    name="direccion"*/}
                                {/*    value={state.direccion}*/}
                                {/*    label={Strings.direccion}*/}
                                {/*    onChange={handleChange}*/}
                                {/*    inputProps={{maxLength: 100}}*/}
                                {/*    fullWidth*/}
                                {/*/>*/}

                                <MapSearch handleChange={(obj:{coordenadas:string})=>setState({...state,...obj})}
                                           direccion={state.direccion??""} coordenadas={state.coordenadas}/>

                                {/*<MapSearch handleChange={({cliDireccion: direccion,cliCoordenadas: coordenadas })=>*/}
                                {/*           setState({...state,direccion,coordenadas})}*/}
                                {/*           cliDireccion = {state.direccion} cliCoordenadas={state.coordenadas}/>*/}

                            </Grid>
                            <Grid item xs={12}  sm={cliTipo === 2?6:5} md={cliTipo === 2?6:5} lg={5}>
                                <TextField
                                    name="direccion2"
                                    label={Strings.direccion + " 2"}
                                    placeholder={Strings.referenciaDireccion}
                                    value={state.direccion2}
                                    onChange={handleChange}
                                    inputProps={{maxLength: 100}}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={6} sm={3} lg={2}>
                                <TextField
                                    name="codigoPostal"
                                    label={Strings.codigoPostal}
                                    value={state.codigoPostal}
                                    onChange={handleChange}
                                    inputProps={{maxLength: 20}}
                                    fullWidth
                                />
                            </Grid>

                            {cliTipo !== 2 &&
                            <Grid item xs={12} sm={4} lg={3}>
                                    <DateInput
                                        openTo={"year"}
                                        clearable
                                        value={state.fechaNacimiento}
                                        name="fechaNacimiento"
                                        label={Strings.fechaNacimiento}
                                        onChange={handleChange}
                                        fullWidth native={undefined} views={undefined} quincenalFijo={undefined}
                                    />
                            </Grid>}
                            <Grid item xs={12} sm={4} md={5} lg={3}>
                                <TextField
                                    name="email"
                                    type={"email"}
                                    label={Strings.email}
                                    value={state.email}
                                    onChange={handleChange}
                                    inputProps={{maxLength: 50}}
                                    fullWidth
                                />
                            </Grid>
                            {isPrivate &&
                                <Grid item xs={12} sm={8} md={4} lg={3}>
                                    <SelectRuta value={state.rutaId}
                                                name={"rutaId"}
                                                label={Strings.ruta}
                                                onChange={handleChange}  />
                                </Grid>
                            }

                            {customFormInputCli && Object.keys(customFormInputCli).map((key)=>
                                <Grid item xs={12} sm={4} lg={3} key={key}>

                                    {!!(customFormInputCli)[key].source?(
                                        <SelectUsoMultiples
                                            emptyOption={{key:0,value:Strings.ninguna}}
                                            group={customFormInputCli[key].source ?? ""}
                                            name={"clienteCampo"+key.slice(-1)}
                                            label={customFormInputCli[key].name ?? ""}
                                            required={customFormInputCli[key].isRequired}
                                            value={(state as any)["clienteCampo"+key.slice(-1)] ? (state as any)["clienteCampo"+key.slice(-1)] : undefined}
                                            onChange={handleChange}
                                            // inputProps={{maxLength: 50}}
                                        />

                                    ):(
                                        <TextField
                                            name={"clienteCampo"+key.slice(-1)}
                                            label={customFormInputCli[key].name}
                                            required={customFormInputCli[key].isRequired}
                                            value={(state as any)["clienteCampo"+key.slice(-1)] ? (state as any)["clienteCampo"+key.slice(-1)] : ""}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 50}}
                                            fullWidth
                                        />
                                    )}

                                </Grid>
                            )}

                            {/*anterior*/}
                            {/*{customFormInputCli && Object.keys(customFormInputCli).map((key)=>*/}
                            {/*    <Grid item xs={12} sm={4} lg={3} key={key}>*/}
                            {/*        <TextField*/}
                            {/*            name={key}*/}
                            {/*            label={customFormInputCli[key].name}*/}
                            {/*            required={customFormInputCli[key].isRequired}*/}
                            {/*            value={state[key] ? state[key] : ""}*/}
                            {/*            onChange={handleChange}*/}
                            {/*            inputProps={{maxLength: 50}}*/}
                            {/*            fullWidth*/}
                            {/*        />*/}
                            {/*    </Grid>*/}
                            {/*)}*/}
                        </Grid>
                    </div>
                    <AddAdjuntos permitirDocumentos={permitirDocumentos} adjuntos={state.archivos} onChange={(archivos:IArchivo[])=>setState({...state,archivos})} />

                    {state.condicionLaboral === 1 &&
                        <div className={"customCard"}>
                            <Typography color={"primary"} className={"title"}>{Strings.empresa}</Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                name="trabajoNombre"
                                label={Strings.nombres}
                                value={state.trabajoNombre}
                                onChange={handleChange}
                                inputProps={{maxLength: 50}}
                                fullWidth
                                required
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <SelectEnum value={state.trabajoIntervaloCobro} name={"trabajoIntervaloCobro"}
                                            label={Strings.intervaloCobro} onChange={handleChange} group={"ciclosPago"} />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    name="diaCobro"
                                    label={Strings.diasCobro}
                                    value={state.diaCobro}
                                    onChange={handleChange}
                                    inputProps={{maxLength: 50}}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                name="trabajoPosicion"
                                label={Strings.posicion}
                                value={state.trabajoPosicion}
                                onChange={handleChange}
                                inputProps={{maxLength: 50}}
                                fullWidth
                                required
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                name="tiempoLaborando"
                                label={Strings.tiempoLaborando}
                                value={state.tiempoLaborando}
                                onChange={handleChange}
                                inputProps={{maxLength: 50}}
                                fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextFieldPhone
                                name="trabajoTelefono"
                                label={Strings.telefono}
                                value={state.trabajoTelefono}
                                onChange={handleChange}
                                fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                name="trabajoDireccion"
                                label={Strings.direccion}
                                value={state.trabajoDireccion}
                                onChange={handleChange}
                                inputProps={{maxLength: 100}}
                                fullWidth
                                />
                            </Grid>
                        </Grid>
                        </div>
                    }
                    <>

                        <div className={"customCard"} >


                            <Box className={"title"} display='flex' p={"0 10px  !important"} sx={{width: 'calc(100% - 4px) !important'}}>
                                <Typography sx={{flex: '1 1 100%',fontSize:14, fontWeight:"bold", pt:"6px", pb:"6px"}} color={"secondary"}>
                                    DATOS DEL PRESTAMO
                                </Typography>
                                {isAuthenticated &&
                                    <Button type="button" size={"small"} color={"primary"} sx={{mr:1}}
                                            onClick={() => navigate(pathname, {state:{showCal: true}})}
                                    >
                                        {Strings.amortizacion}
                                    </Button>
                                }
                            </Box>

                        <Grid container spacing={3}>
                            {isPrivate &&
                                <Grid item xs={6} sm={4} md={4} lg={3} xl={2} >
                                    <SelectEnum value={state.tipoAmortizacion} name={"tipoAmortizacion"} label={Strings.amortizacion} required={!editar}
                                                onChange={handleChange} group={"tiposAmortizacion"} />
                                </Grid>
                            }


                                <Grid item xs={6} sm={4} md={4} lg={3} xl={2} >
                                    <SelectEnum value={state.ciclosPago} name={"ciclosPago"} label={Strings.modalidad} required={!editar}
                                                onChange={handleChange} group={"ciclosPago"} />
                                </Grid>
                            <Grid item xs={6} sm={4} md={4} lg={3} xl={2} >
                                <TextFieldCurrency
                                    name="prestamoCapital"
                                    label={Strings.monto +" "+Strings.aPrestar}
                                    value={state.prestamoCapital}
                                    onChange={handleChange}
                                    fullWidth
                                    required
                                    //    min={5}
                                />
                            </Grid>
                            <Grid item xs={6} sm={4} md={4} lg={3} xl={2} >
                                <TextField
                                    name="plazo"
                                    label={"# "+Strings.cuotas}
                                    type="number"
                                    inputProps={{step:1,inputMode:"numeric"}}
                                    required={!editar}
                                    value={state.plazo}
                                    fullWidth
                                    onChange={handleChange}
                                />
                            </Grid>
                                {isPrivate &&
                                    <Grid item xs={6} sm={4} md={4} lg={3} xl={2} >
                                        <FormControl
                                            disabled={!!state.montoCuota}
                                            required={!editar && !state.montoCuota}
                                            fullWidth>
                                            <InputLabel htmlFor="tasaInteres">
                                                {Strings.tasaInteres} &nbsp;
                                                {!!state.ciclosPago && <SelectEnum value={state.ciclosPago} group={"ciclosPago"}/>}
                                            </InputLabel>
                                            <Input id="tasaInteres"
                                                   disabled={!!state.montoCuota}
                                                   name="tasaInteres"
                                                   value={state.tasaInteres}
                                                   type="number"
                                                   inputProps={{step: "any", inputMode: "decimal"}}
                                                   required={!editar}
                                                   onChange={handleChange}
                                                   startAdornment={<InputAdornment position="start">%</InputAdornment>}

                                            />
                                        </FormControl>
                                    </Grid>
                                }

                            {isPrivate && <>
                                    <Grid item xs={6} sm={4} md={4} lg={3} xl={2} >
                                        <HtmlTooltip title={
                                            <em> {Strings.interesDesconocidoMsj}</em>
                                        } disableHoverListener>
                                            <div>
                                                <TextFieldCurrency
                                                    name="montoCuota"
                                                    value={state.montoCuota}
                                                    onChange={handleChange}
                                                    fullWidth
                                                    placeholder={"Opcional"}
                                                    label={Strings.monto+" "+Strings.cuotas}
                                                    InputProps={(state.montoCuota && state.plazo && state.prestamoCapital && state.tipoAmortizacion) ? {
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <HtmlTooltip title={"Calcular tasa de interés."}>
                                                                    <IconButton disabled={fetchingTasa} color={"primary"} onClick={getTasaInteres} size="large">
                                                                        {fetchingTasa?<CircularProgress size={20} color="inherit"/>:<CalculateOutlined/>}
                                                                    </IconButton>
                                                                </HtmlTooltip>
                                                            </InputAdornment>
                                                        ),
                                                    }:{}}
                                                />
                                            </div>
                                        </HtmlTooltip>
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={4} lg={3} xl={2} >
                                        <DateInput
                                            name="fechaProximoPago"
                                            value={state.fechaProximoPago}
                                            label={Strings.primerPago}
                                            onChange={handleChange}
                                            quincenalFijo={state.ciclosPago === 16}
                                            fullWidth native={undefined} views={undefined} clearable={undefined}
                                            openTo={undefined}
                                        />
                                    </Grid>
                                </>}


                            {customFormInputPre && Object.keys(customFormInputPre).map((key)=>
                                <Grid item key={key} xs={12} sm={4} md={4} lg={3}>

                                    {!!(customFormInputPre)[key].source?(
                                        <SelectUsoMultiples
                                            emptyOption={{key:0,value:Strings.ninguna}}
                                            group={customFormInputPre[key].source ?? ""}
                                            name={"prestamoCampo"+key.slice(-1)}
                                            label={customFormInputPre[key].name ?? ""}
                                            required={customFormInputPre[key].isRequired}
                                            value={(state as any)["prestamoCampo"+key.slice(-1)] ? (state as any)["prestamoCampo"+key.slice(-1)] : undefined}
                                            onChange={handleChange}
                                            // inputProps={{maxLength: 50}}
                                        />

                                    ):(
                                        <TextField
                                            name={"prestamoCampo"+key.slice(-1)}
                                            label={customFormInputPre[key].name}
                                            required={customFormInputPre[key].isRequired}
                                            value={(state as any)["prestamoCampo"+key.slice(-1)] ? (state as any)["prestamoCampo"+key.slice(-1)] : ""}
                                            onChange={handleChange}
                                            inputProps={{maxLength: 50}}
                                            fullWidth
                                        />
                                    )}

                                </Grid>
                            )}

                        </Grid>
                        </div>
                        {isPrivate && <>
                            <div className={"customCard"}>
                                <Typography color={"primary"} className={"title"}>OTROS</Typography>
                                <Grid container spacing={3}>
                                    {state.ciclosPago?.toString() === "1" &&
                                        <Grid item xs={12}  sm={4} lg={3}>
                                            <SelectDay
                                                name={"diasExcluidos"}
                                                value={state.diasExcluidos}
                                                onChange={({target})=>setState({...state,diasExcluidos: target.value})}
                                            />
                                        </Grid>
                                    }
                                    <Grid item xs={12} sm={4} md={4} lg={3}>
                                        <SelectCaja
                                            name="cajaId"
                                            label={Strings.caja}
                                            value={state.cajaId}
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={3} lg={2}>
                                        <TextField
                                            name="prestamoReferencia"
                                            label={Strings.codigoRef}
                                            value={state.prestamoReferencia}
                                            fullWidth
                                            onChange={handleChange}
                                            inputProps={{maxLength: 20}}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={2}>
                                        <TextFieldCurrency
                                            name="gastosLegales"
                                            type={"number"}
                                            label={Strings.gastosLegales}
                                            value={state.gastosLegales}
                                            fullWidth
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={3} lg={2}>
                                        <TextField
                                            name="porcientoMora"
                                            type="number"
                                            inputProps={{step:"any",inputMode:"decimal"}}
                                            label={Strings.mora}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                            }}
                                            value={state.porcientoMora}
                                            fullWidth
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={3}>
                                        <TextField
                                            name="porcientoComision"
                                            label={Strings.comision}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                            }}
                                            type={"number"}
                                            inputProps={{
                                                max:100,
                                                step:"any",
                                                inputMode:"decimal"
                                            }}
                                            value={state.porcientoComision}
                                            fullWidth
                                            onChange={handleChange}
                                        />
                                    </Grid>

                                    {!!state.porcientoComision &&
                                        <Grid item xs={12} sm={4} md={3}>
                                            <SelectAgente
                                                name="usuarioIdAgente"
                                                label={Strings.agenteAcomisionar}
                                                value={state.usuarioIdAgente}
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                    }
                                    <Grid item xs={12} sm={4} lg={3}>
                                        <SelectCartera value={state.carteraId}
                                                       name={"carteraId"}
                                                       label={Strings.cartera}
                                                       onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={3}>
                                        <TextFieldCurrency
                                            name="montoSeguro"
                                            label={Strings.monto +" "+Strings.seguro}
                                            value={state.montoSeguro}
                                            onChange={handleChange}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={3}>
                                        <TextFieldCurrency
                                            name="inicial"
                                            label={Strings.inicial}
                                            value={state.inicial}
                                            onChange={handleChange}
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        </>}
                        <div className={"customCard"}>
                            <Typography color={"primary"} className={"title"}>{Strings.codeudor.toUpperCase()}</Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        name="codeudor"
                                        label={Strings.nombreCompleto}
                                        value={state.codeudor}
                                        fullWidth
                                        onChange={handleChange}
                                        inputProps={{maxLength: 50}}
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <TextField
                                        name="codeudorCedula"
                                        label={Strings.cedula}
                                        value={state.codeudorCedula}
                                        fullWidth
                                        onChange={handleChange}
                                        inputProps={{maxLength: 50}}
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <TextFieldPhone
                                        name="codeudorTelefono"
                                        label={Strings.telefono}
                                        value={state.codeudorTelefono}
                                        fullWidth
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        name="codeudorDireccion"
                                        label={Strings.direccion}
                                        value={state.codeudorDireccion}
                                        fullWidth
                                        onChange={handleChange}
                                        inputProps={{maxLength: 100}}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </>
                    <ReferenciasCliente referencias={state.referencias}
                                        onChange={(referencias)=>setState({...state,referencias})} />
                </form>

                {isPrivate ?(
                    <>
                        {state.estado === ESTADO_SOLICITUD.PENDIENTE &&
                            <Box className={"formControl"}>
                                {editar?(
                                    <>
                                        <Button sx={{mr: 0.5}} color={"error"} onClick={onCancelEdit} variant={"outlined"}
                                                disabled={status === "loading"} startIcon={<Close/>}
                                                size={"small"}>{Strings.cancelar}</Button>
                                        <Button type={"submit"} form={"form1"} variant={"outlined"} disabled={status === "loading"}
                                                startIcon={<Save/>} size={"small"}>
                                            {status === "loading" ? (
                                                <span><CircularProgress size={14} color="inherit"/> &nbsp; {Strings.cargando}</span>
                                            ) : (
                                                <span>{Strings.guardar}</span>
                                            )}
                                        </Button>
                                    </>
                                ):(
                                    <>

                                        {hasPermissionTo(PERSMISOS.solicitudesActualizar) &&
                                            <Button sx={{mr: "auto"}} size={"small"} variant={"outlined"}  onClick={onClickEdit} color={"primary"} startIcon={<Edit/>}>{Strings.editar}</Button>
                                        }

                                        {hasPermissionTo(PERSMISOS.solicitudesRechazar) && state.estado === 1 &&
                                            <Button sx={{mr: 0.5}} size={"small"} variant={"outlined"}  disabled={isPending} color={"error"} startIcon={<Close/>} onClick={onRechazar}>
                                                {Strings.rechazar}
                                            </Button>
                                        }
                                        {hasPermissionTo(PERSMISOS.solicitudesAprobar) && state.estado !== 2 &&
                                            <Button  size={"small"} variant={"outlined"}  disabled={isPending} color={"primary"}  startIcon={<Check/>} type="submit" form={"form1"}>{Strings.aprobar}</Button>
                                        }
                                    </>
                                )}



                                {/*{hasPermissionTo(PERSMISOS.solicitudesActualizar) && state.estado !== 2 &&*/}
                                {/*    <Button color="primary" disabled={isPending} type="button" onClick={editar}>{Strings.guardar}</Button>*/}
                                {/*}*/}
                            </Box>
                        }
                    </>
                ):(
                    <Button color="primary" fullWidth={webview} variant={"contained"} disabled={isPending} type="submit" form={"form1"}>{Strings.enviar} {Strings.solicitud}</Button>
                )}
            </div>



            {urlState && urlState.showCal &&
            <AmortCal onClose={()=>navigate(-1)}
                      inicialState={{
                        fechaPrimerPago: state.fechaProximoPago,
                        monto: state.prestamoCapital,
                        tasa: state.tasaInteres,
                        cuotas: state.plazo,
                        cicloPago:state.ciclosPago,
                        tipoAmortizacion:state.tipoAmortizacion,
                        montoCuota:state.montoCuota

                      }}
                      onUseVal={(val:any)=>{
                          setState(prevState => ({
                              ...prevState,
                              fechaProximoPago: val.fechaPrimerPago,
                              prestamoCapital: val.monto,
                              tasaInteres: val.tasa,
                              plazo: val.cuotas,
                              ciclosPago: val.cicloPago,
                              tipoAmortizacion: val.tipoAmortizacion,
                              montoCuota: val.montoCuota
                          }))
                      }} />
            }
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={!!snackbarMsj}
                onClose={()=>setSnackbarMsj(null)}
                message={snackbarMsj}
                autoHideDuration={6000}
            />
        </Fragment>
    );

}

